import React, { useState, useEffect, useRef } from "react";
import "./EcommerceProduct.scss"
import { useParams } from 'react-router';
import Header from "../../components/Header/Header";
import ProductsContent from "./ProductsContent";
import { sortByOrderAscending } from "../../helper/helper";
import FiltersComponent from "./FiltersComponent";
import { useDispatch, useSelector } from "react-redux";
import { getEcomProdCategories, getEcomProdCategoriesCount, getEcomProdFilterCategories, getEcomProdFilterCategoriesCount } from "../../../../../utilities/apiRequests/productRegistryServerRequests";
import arrow from "../../assets/arrow-right.svg"
import { setCategoryProducts, setSelectedCategory } from "../../../../../../../redux/companyDataSlice";
import Pagination from "../../components/Pagination/Pagination";

const EcommerceProduct = () => {
    const params = useParams();
    const dispatch = useDispatch()
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "productCategory")
    const companyDetails = useSelector((state) => state.companyData.company)
    const [header, setHeader] = useState("")
    const [isOpen, setIsOpen] = useState(false)
    const [filters, setFilters] = useState({})
    const categories = useSelector((state) => state.companyData.categories)
    const selectedCategory = useSelector((state) => state.companyData.selectedCategory)
    const categoryProducts = useSelector((state) => state.companyData.categoryProducts)

    const [range, setRange] = useState({ min: 0, max: 1000 });

    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);


    const containerRef = useRef(null);
    const [showRightArrow, setShowRightArrow] = useState(false);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [loading, setLoading] = useState(true)

    const [count, setCount] = useState("0")
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (params.category) {
            setHeader(params.category)
        }
    }, [params.category])
    useEffect(() => {
        const scrollContainerEcom = containerRef.current;
        if (scrollContainerEcom) {
            const handleScroll = () => {
                const { scrollLeft, scrollWidth, clientWidth } = scrollContainerEcom;
                setShowLeftArrow(scrollLeft > 0);
                setShowRightArrow(scrollLeft + clientWidth + 20 < scrollWidth);
            };

            handleScroll();

            scrollContainerEcom.addEventListener("scroll", handleScroll);
            window.addEventListener("resize", handleScroll);

            return () => {
                scrollContainerEcom.removeEventListener("scroll", handleScroll);
                window.removeEventListener("resize", handleScroll);
            };
        }
    }, [categories]);

    const scrollRight = () => {
        containerRef.current?.scrollBy({ left: 250, behavior: 'smooth' });
    };

    const scrollLeft = () => {
        containerRef.current?.scrollBy({ left: -250, behavior: 'smooth' });
    };

    useEffect(() => {
        fetchCatData()
        let rangeVal = {
            max: 1000,
            min: 0
        }
        fetchFilterData(rangeVal)
    }, [selectedCategory, currentPage])
    const fetchCatData = async () => {
        if (categories.length > 0) {
            let skip = (currentPage - 1) * 12
            await getEcomProdCategories(companyDetails?.OrganisationID, selectedCategory.ProductCategory?.ProductCategoryID, skip).then(async (data) => {
                dispatch(setCategoryProducts(data))
                localStorage.setItem("ECOM_CAT_PROD_DEF", JSON.stringify(data))
                let countdata = await getEcomProdCategoriesCount(companyDetails?.OrganisationID, selectedCategory?.ProductCategory?.ProductCategoryID)
                setTotalItems(Number(countdata))
                setFilters(data?.ProductFilter?.ProductFilterControls)
            })
        }
    }
    const fetchFilterData = async (rangeVal) => {
        if (categories.length > 0) {
            setLoading(true)
            const apiReqBody = {
                MaxPrice: rangeVal.max,
                MinPrice: rangeVal.min,
                Weight: [],
                ProductCategoryIDs: [selectedCategory.ProductCategory?.ProductCategoryID],
                ProductSubCategoryIDs: [],
                BrandIDs: [],
            }
            let skip = (currentPage - 1) * 12
            await getEcomProdFilterCategories(companyDetails?.OrganisationID, apiReqBody, skip).then(async (data) => {
                let countdata = await getEcomProdFilterCategoriesCount(companyDetails?.OrganisationID, apiReqBody)
                setTotalItems(Number(countdata))
                dispatch(setCategoryProducts(data))
                setCount(data?.Result?.length)
                setLoading(false)
            })
        }
    }

    const toggleDrawer = () => {
        setIsOpen(!isOpen);
    };
    const onapplyFilterclick = () => {
        fetchFilterData(range)
    }
    const clearClick = () => {
        let rangeVal = {
            max: 1000,
            min: 0
        }
        fetchFilterData(rangeVal)
    }
    const Components = page?.Components || []
    const getProductsComponents = (component) => {
        switch (component.ID) {
            case "Web-Filter-Component":
                return categories.length > 0 ? <FiltersComponent isWeb={true} isOpen={isOpen} filters={filters} range={range} setRange={setRange} onapplyFilterclick={onapplyFilterclick} clearClick={clearClick} /> : ""
            case "Web-Products-content":
                return <ProductsContent toggleDrawer={toggleDrawer} components={component.Components} isLoading={loading} count={count} />


            default:
                return <div />
        }

    }
    const getProductsSection = (components) => {
        return (
            <>
                <div className="EcommerceContact-content" >
                    {sortByOrderAscending(components).map((component, key) => {
                        return getProductsComponents(component)

                    })}
                </div>

                {!loading && categoryProducts?.Result?.length > 0 && <div className="pagination-content">
                    <Pagination
                        totalItems={totalItems}
                        itemsPerPage={12}
                        currentPage={currentPage}
                        onPageChange={(e) => {
                            setCurrentPage(e)
                            window.scrollTo({
                                top: 520,
                                behavior: 'smooth'
                            });
                        }}
                    />
                </div>}
            </>
        )
    }
    const images = [
        "https://i.pinimg.com/736x/15/8f/dd/158fdd965744b4a38eef2c61dfcc5b35.jpg",
        "https://i.pinimg.com/736x/9e/ab/19/9eab19d75aed939b565b1d72536af48e.jpg",
        "https://i.pinimg.com/736x/37/1f/bd/371fbd6574c669620def6d2125b7b014.jpg",
        "https://i.pinimg.com/736x/fb/5e/aa/fb5eaafed6a7f5c5dad0c7908de99e35.jpg",
        "https://i.pinimg.com/736x/22/9d/ab/229dab3a208ed414afce3b866a38bd12.jpg",
        "https://i.pinimg.com/736x/46/ea/7b/46ea7b5def24cb1daad84905e639f88a.jpg",
        "https://i.pinimg.com/736x/85/a8/14/85a81430b481c2fd260e8458d722c887.jpg",
        "https://i.pinimg.com/736x/9e/a8/07/9ea8072e400317b1084470bebc52e1aa.jpg"
    ]
    const getCategories = () => {
        return (
            <div className="EcommerceProduct-category" >
                {showLeftArrow && (
                    <div
                        onClick={scrollLeft}
                        className="arrow-left"
                    >
                        <img alt="" src={arrow} />

                    </div>
                )}

                {categories.length > 0 && <div className="EcommerceProduct-category-list" ref={containerRef}>
                    {categories.map((coll, key) => {
                        return (
                            <div
                                className="item-collection"
                                key={key}
                                style={{
                                    backgroundImage: `linear-gradient(
                                        to bottom,
                                        rgba(0, 0, 0, 0) 0%, 
                                        rgba(0, 0, 0, 0.8) 100%
                                      ), url(${images[key]})`
                                }}
                                onClick={() => {
                                    dispatch(setSelectedCategory(coll))
                                }}
                            >
                                <div className="title-text">
                                    {coll?.ProductCategory?.Category.toLowerCase()}
                                </div>
                            </div>
                        );
                    })}
                </div>}

                {showRightArrow && (
                    <div
                        onClick={scrollRight}
                        className="arrow-right"
                    >
                        <img alt="" src={arrow} />
                    </div>
                )}
            </div>
        );
    };

    const getComponents = (component) => {
        switch (component.ID) {
            case "Mobile-Filter-Component":
                return categories.length > 0 ? <FiltersComponent isWeb={false} isOpen={isOpen} filters={filters} range={range} setRange={setRange} onapplyFilterclick={onapplyFilterclick} toggleDrawer={toggleDrawer} clearClick={clearClick} /> : ""
            case "Header":
                return <div className="EcommerceProduct-header ">
                    <Header text={header} textAlign="center" />
                    {getCategories()}
                </div>
            case "Products-Content":
                return getProductsSection(component.Components)
            default:
                return <div />
        }

    }
    return (
        <div className="EcommerceProduct">
            {sortByOrderAscending(Components).map((component, key) => {
                return getComponents(component)

            })}


        </div>
    )
}
export default EcommerceProduct